import { ChartInterval, Charts, Ont, OntEthernetStatus, OntOpticalDdmInfo, OntOpticalDdmInfosBySerial, OntRealTimeData, OntsBySerialNum, RRDdata } from "@ip6m/types";
import { Controller, Get, Param, UseGuards } from '@nestjs/common';
import { ApiOperation, ApiParam, ApiResponse, ApiTags } from "@nestjs/swagger";
import { DataCollectorService } from "./services/datacollector.service";
import { DDMService } from "./services/ddm.service";
import { DeviceService } from "./services/device.service";
import { RRDService } from "./services/rrd_database.service";
import { EthernetStatusService } from "./services/ethernet-status.service";
import { IsAuthenticatedGuard } from '@ip6m/server/auth';

@ApiTags('snmp-api-datacollector')
@Controller('v1/datacollector')
@UseGuards(IsAuthenticatedGuard)
export class DatacollectorController {

    constructor(
        private dcS: DataCollectorService,
        private deviceS: DeviceService,
        private ddmS: DDMService,
        private rrdDB: RRDService,
        private ethSS: EthernetStatusService) {}

    @Get('')
    @ApiOperation({ summary: 'Number of known ONT-s'})
    getDataCollectorOltList() {
        return this.deviceS.stat;
    }

    @Get('ont')
    @ApiOperation({ summary: 'Get all ONTs with "static" data, 5 minutes cached'})
    getOnts(): OntsBySerialNum {
        return this.deviceS.getOnts
    }

    @Get('ont/:ontSn')
    @ApiOperation({ summary: 'Get ONT with "static" data, 5 minutes cached'})
    @ApiParam({
        name: 'ontSn',
        type: 'string',
        example: '48575443AE5FC29B'
    })
    getOnt(@Param() params): Ont {
        return this.deviceS.getOnt(params.ontSn);
    }


    @Get(':ontSn/chart/:interval')
    @ApiOperation({ summary: 'Get urls for chart images by Ont and interval'})
    @ApiParam({
        name: 'ontSn',
        type: 'string',
        example: '48575443AE5FC29B'
    })
    @ApiParam({
        name: 'interval',
        enum: ChartInterval
    })
    getOntCharts(@Param() params): Promise<Charts> {
        return this.rrdDB.getCharts(params.ontSn,params.interval);
    }


    @Get(':ontSn/chartdata/:interval')
    @ApiOperation({ summary: 'Get data from rrd for a set amount of time'})
    @ApiParam({
        name: 'ontSn',
        type: 'string',
        example: '48575443AE5FC29B'
    })
    @ApiParam({
        name: 'interval',
        enum: ChartInterval
    })
    getrrdData(@Param() params): Promise<RRDdata[]> {
        try {
            return this.rrdDB.getRrdData(params.ontSn,params.interval);
        } catch(error) {
            throw new Error(error.message);
        }
    }

    @Get(':ontSn/realtime')
    @ApiOperation({ summary: 'Get OntRealtimeData for Ont'})
    @ApiParam({
        name: 'ontSn',
        type: 'string',
        example: '48575443AE5FC29B'
    })
    @ApiResponse({
        status: 200,
        description: 'OntRealtimeData object'
    })
    getOntRealtime(@Param() params): Promise<OntRealTimeData> {
        return this.dcS.realtime(params.ontSn);
    }

    @Get('ddm')
    @ApiOperation({ summary: 'Get 5 minutes cached OpticalDdmInfo for all Onts'})
    @ApiResponse({
        status: 200,
        description: 'OntOpticalDdmInfosBySerial object',
        schema: {
            type: 'object',
            additionalProperties: {
                type: 'string',
            },
            example: {
                '4857544303741D42': {
                    OpticalDdmTemperature: 68,
                    OpticalDdmBiasCurrent: 16,
                    OpticalDdmTxPower: 230,
                    OpticalDdmRxPower: -1131,
                    OpticalDdmVoltage: 3300,
                    OpticalDdmOltRxOntPower: 8434,
                    OpticalDdmAniCATVRxPower: 383
                },
                '48575443EAF6014E': {
                    OpticalDdmTemperature: 49,
                    OpticalDdmBiasCurrent: 15,
                    OpticalDdmTxPower: 207,
                    OpticalDdmRxPower: -2913,
                    OpticalDdmVoltage: 3260,
                    OpticalDdmOltRxOntPower: 6903,
                    OpticalDdmAniCATVRxPower: -1092
                }
            }
        }
    })
    getOntOpticalDdmInfos(): OntOpticalDdmInfosBySerial {
        return this.ddmS.getAllDDMs;
    }

    @Get(':ontSn/ddm')
    @ApiOperation({ summary: 'Get OpticalDdmInfo for Ont'})
    @ApiParam({
        name: 'ontSn',
        type: 'string',
        example: '485754434BC45640'
    })
    @ApiResponse({
        status: 200,
        description: 'OntOpticalDdmInfo object'
    })
    getOntOpticalDdmInfo(@Param() params): Promise<OntOpticalDdmInfo>  {
        try {
            return this.ddmS.getData(params.ontSn);
        } catch(error) {
            throw new Error(error.message);
        }
    }

    @Get(':ontSn/ethstate')
    @ApiOperation({ summary: 'Get OpticalDdmInfo for Ont'})
    @ApiParam({
        name: 'ontSn',
        type: 'string',
        example: '485754434BC45640'
    })
    @ApiResponse({
        status: 200,
        description: 'OntOpticalDdmInfo object'
    })
    getOntEthernetState(@Param() params): Promise<OntEthernetStatus> {
        try {
          return this.ethSS.getOntEthState(params.ontSn);
        } catch(error) {
          throw new Error(error.message);
        }
    }
}
